import { store } from './Store'
import { setLoadingDate } from './slice/LoadingDateSlice'
import { setSelectedJournal } from './slice/JournalSlice'
import { IJournal } from '../interface/IJournal'
import { injectedEndpoints } from '@/api/InjectedEndpoints'
import { format } from 'date-fns'

export const UpdateStoreHelperJournal = async (date: string, forceRefetch: boolean) => {
  const normalizedDate = format(new Date(date), 'yyyy-MM-dd')

  store.dispatch(setLoadingDate(true))

  try {
    const journal: IJournal = await store.dispatch(injectedEndpoints.endpoints.getJournal.initiate(normalizedDate, { forceRefetch: forceRefetch, subscribe: false })).unwrap()
    store.dispatch(setSelectedJournal(journal))
  } catch (error) {
    console.log(error)
  } finally {
    store.dispatch(setLoadingDate(false))
  }
}
